
import { useState } from 'react';

const faqs = [
  {
    question: 'What welding services do you offer for contractors?',
    answer: 'We provide a full range of contractor welding services including structural steel welding, custom metal fabrication, heavy equipment repair, mobile welding, CNC plasma and torch cutting, AG equipment fabrication, custom gates, metal fencing, handrails, staircases, and ornamental ironwork.',
  },
  {
    question: 'Do you offer 24/7 emergency welding repair?',
    answer: 'Yes. New Generation Welding offers 24/7 emergency mobile welding repair services. Our fully equipped welding rigs can be on your job site quickly to minimize downtime and keep your project on schedule.',
  },
  {
    question: 'What areas do you serve?',
    answer: 'We are based in Yuba County, California and provide welding and fabrication services throughout Northern California and Southern California. Our mobile welding crews travel to job sites across the state.',
  },
  {
    question: 'Are you licensed and insured?',
    answer: 'Absolutely. New Generation Welding is fully licensed and insured, meeting all requirements for commercial and industrial construction projects. We carry comprehensive liability coverage for your peace of mind.',
  },
  {
    question: 'How quickly can I get a quote?',
    answer: 'Most quotes are returned within 24 hours. For urgent projects, call us directly at 530-806-8659 and we can often provide a same-day estimate over the phone or with a quick site visit.',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-24 bg-white">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-10 h-0.5 bg-[#E8740C]"></div>
            <span className="text-[#E8740C] text-xs font-semibold tracking-[0.2em] font-heading uppercase">FAQ</span>
            <div className="w-10 h-0.5 bg-[#E8740C]"></div>
          </div>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-[#1A1A1A] leading-tight">
            FREQUENTLY ASKED <span className="text-[#E8740C]">QUESTIONS</span>
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div key={idx} className="border border-[#E8E6E2] rounded-lg overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-[#F8F7F5] transition-colors"
              >
                <span className="text-[#1A1A1A] font-heading font-bold text-sm pr-4">{faq.question}</span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className={`ri-arrow-down-s-line text-[#E8740C] text-xl transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`}></i>
                </div>
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${openIndex === idx ? 'max-h-60' : 'max-h-0'}`}>
                <p className="px-6 pb-5 text-[#6A6A6A] text-sm leading-relaxed font-body">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
